import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import SortIcon from '@mui/icons-material/Sort';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import { setIsNewTut } from '../../../redux/slices/tutorialEditSlice';
import AdminModuleAPIs from '../../../utilities/api/tutorials/AdminModuleAPIs';
import TutorialContent from './TutorialContent';
import nodatafound from '../../../utilities/dummy_assets/nodatafound.jpg';
import { FilterIcon } from '../../../Icons/DashboardIcons';

const TutorialPage = () => {
  const user = useSelector(state => state.user.user);
  const dispatch = useDispatch();
  const [activeView, setActiveView] = useState(0);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        setLoading(true);
        const response = await AdminModuleAPIs.ModuleListGet();
        setData(response.reverse());
      } catch (error) {
        console.error('Error fetching module list:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, [user]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {/* Main Content */}
      <Box sx={{ flex: 1, p: 2 }}>
        {/* Search and Controls Bar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            gap: 2,
          }}
        >
          {/* Search Bar and Filters */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              placeholder="Search...."
              // size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#7A7A7A' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '350px',
                '& .MuiOutlinedInput-root': {
                  border: '1px solid #E6E6E6',
                  backgroundColor: '#FAFAFA',
                  color: '#7A7A7A',
                  borderRadius: '8px',
                  fontSize: '16px',
                  '& .MuiOutlinedInput-input': {
                    paddingY: '14px'
                  }
                },
              }}
              onChange={e => setSearch(e.target.value)}
            />
            {/* Filter and Sort Icons - Hidden for now */}
            {/* <IconButton
              size="small"
              sx={{
                border: '1px solid #B5B5B5',
                borderRadius: '12px',
                backgroundColor: '#F4F4F4',
                p: "12px 16px",
              }}
            >
              <FilterIcon width="24px" height="24px" />
            </IconButton>
            <IconButton
              size="small"
              sx={{
                border: '1px solid #B5B5B5',
                borderRadius: '12px',
                backgroundColor: '#F4F4F4',
                p: "12px 16px",
              }}
            >
              <SortIcon sx={{ fontSize: '24px', color: '#666' }} />
            </IconButton> */}
          </Box>

          {/* Add Module and View Toggles */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                backgroundColor: '#3F3F3F',
                minWidth: '170px',
                padding: "12px 16px",
                color: '#fff',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '16px',
                borderRadius: '12px',
                '&:hover': {
                  backgroundColor: '#222',
                },
              }}
              onClick={() => dispatch(setIsNewTut(true))}
            >
              Add Module
            </Button>
            {/* Grid/List View Toggles */}
            <Box
              sx={{
                display: 'flex',
                gap: 1,
              }}
            >
              <IconButton
                size="small"
                onClick={() => setActiveView(0)}
                sx={{
                  p: '5px',
                  backgroundColor: activeView === 0 ? '#5C5C5C' : 'transparent',
                  color: activeView === 0 ? '#fff' : '#5C5C5C',
                  border: '1px solid #5C5C5C',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    color: '#5C5C5C',
                  },
                }}
              >
                <GridViewOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => setActiveView(1)}
                sx={{
                  p: '5px',
                  backgroundColor: activeView === 1 ? '#5C5C5C' : 'transparent',
                  color: activeView === 1 ? '#fff' : '#5C5C5C',
                  border: '1px solid #5C5C5C',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    color: '#5C5C5C',
                  },
                }}
              >
                <ViewListOutlinedIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* Content */}
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '60vh',
            }}
          >
            <CircularProgress />
          </Box>
        ) : data.length > 0 ? (
          <TutorialContent
            data={data}
            searchQuery={search}
            activeView={activeView}
            setSearch={setSearch}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '60vh',
            }}
          >
            <Box textAlign="center">
              <img
                src={nodatafound}
                alt="No data found"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
              <Typography variant="h6" color="textSecondary" sx={{ mt: 2 }}>
                No data available
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TutorialPage;
